exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:1900px){.title-sub-header[data-v-87bcbd98]{font-size:16px!important}}.sub-header[data-v-87bcbd98]{font-size:larger;font-weight:600;color:#495f74}.title-header[data-v-87bcbd98]{font-weight:500;color:#666;font-size:26px}.title-sub-header[data-v-87bcbd98]{font-size:20px;color:#7e7e7e;font-weight:500}.value[data-v-87bcbd98]{font-size:30px;font-weight:700}.box-shadow[data-v-87bcbd98]{border-radius:5px;box-shadow:0 0 15px 3px #ebebeb}", ""]);

// exports
